import script from "./ExpiryDatesView.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpiryDatesView.vue?vue&type=script&setup=true&lang=js"

import "./ExpiryDatesView.vue?vue&type=style&index=0&id=62ee19e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62ee19e4"]])

export default __exports__